import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import 'CssFolder/chart.scss';
import languageModel from "../../../models/language.model";

export default function SalesPerformanceMonthlySelloutParetoChartComponent() {
    let data;
    let SPMSReportCategory;
    let series;
    let paretoSeries;
    let root;
    let chart;
    let xAxis;
    let yAxis;
    let chartID = "SalesPerformanceMonthlySelloutParetoChart";
    let legend;

    let onChartDataChanged = (_data, _spmsReportCategory) => {
        data = _data;
        SPMSReportCategory = _spmsReportCategory;
        am5.array.each(am5.registry.rootElements, function (root) {
            if (root && root.dom.id == chartID) {
                root.dispose();
            }
        });
        initChart();
    }
    let initChart = () => {
        root?.dispose(); // dispose any pre-existing roots
        
        // Create root element
        // https://www.amcharts.com/docs/v5/getting-started/#Root_element
        root = am5.Root.new(chartID);

        // Set themes
        // https://www.amcharts.com/docs/v5/concepts/themes/
        root.setThemes([
            am5themes_Animated.new(root)
        ]);

        // Create chart
        // https://www.amcharts.com/docs/v5/charts/xy-chart/
        chart = root.container.children.push(am5xy.XYChart.new(root, {
            panX: false,
            panY: false,
            wheelX: "panX",
            wheelY: "zoomX",
            paddingTop: 40,
            layout: root.verticalLayout
        }));

        var colors = chart.get("colors");
        colors.set("colors", [
            am5.color(0xAAFFBE)
        ]);

        prepareParetoData();

        // Create axes
        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
        xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
            minZoomCount: 5,
            maxZoomCount: 30,
            categoryField: "marketingName",
            renderer: am5xy.AxisRendererX.new(root, {
                minGridDistance: 10
            })
        }));

        xAxis.labelsContainer.set("tooltip",
            am5.Tooltip.new(root, { pointerOrientation: "down" })
        );

        var xRenderer = xAxis.get("renderer");

        xRenderer.labels.template.setAll({
            rotation: -55,
            centerX: am5.p100,
            centerY: am5.p50,
            fontSize: 13,
            paddingRight: 10,
            paddingTop: 10,
            tooltipText: "{marketingName}",
            oversizedBehavior: "truncate",
            maxWidth: 170
            //ellipsis: "..."
        });

        xRenderer.labels.template.setup = function (target) {
            target.set("background",
                am5.Rectangle.new(root, {
                    fill: am5.color(0x000000), fillOpacity: 0
                })
            );
        };
        //change grid line to white
        xRenderer.grid.template.setAll({
            stroke: am5.color(0xFFFFFF),
            strokeWidth: 1
        });

        xAxis.data.setAll(data);

        yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
            min: 0,
            maxPrecision: 0,
            renderer: am5xy.AxisRendererY.new(root, {})
        }));

        var yRenderer = yAxis.get("renderer");
        //change grid line to white
        yRenderer.grid.template.setAll({
            stroke: am5.color(0xFFFFFF),
            strokeWidth: 1
        });

        yRenderer.labels.template.setAll({
            fontSize: 12,
        });

        var paretoAxisRenderer = am5xy.AxisRendererY.new(root, { opposite: true });
        var paretoAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
            renderer: paretoAxisRenderer,
            min: 0,
            max: 100,
            strictMinMax: true
        }));

        paretoAxisRenderer.grid.template.set("forceHidden", true);
        paretoAxis.set("numberFormat", "#'%");

        paretoAxisRenderer.labels.template.setAll({
            fontSize: 12,
        });

        // Add series
        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
        series = chart.series.push(am5xy.ColumnSeries.new(root, {
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: SPMSReportCategory == 1 ? "validEULAAmt" : "validEULAQty",
            categoryXField: "marketingName"
        }));

        series.columns.template.setAll({
            tooltipText: "{valueY}",//"{categoryX}: {valueY}",
            tooltipY: 0,
            strokeOpacity: 0,
            cornerRadiusTL: 6,
            cornerRadiusTR: 6
        });

        // series.columns.template.adapters.add("fill", function (fill, target) {
        //     return chart.get("colors").getIndex(series.dataItems.indexOf(target.dataItem));
        // });


        series.columns.template.adapters.add("fill", function (fill, target) {
            var index = series.dataItems.indexOf(target.dataItem);
            if (data[index].pareto >= 80)
                return am5.color(0xB5B5B5);
            else
                return am5.color(0x8093DC);
        })


        // pareto series
        paretoSeries = chart.series.push(am5xy.LineSeries.new(root, {
            xAxis: xAxis,
            yAxis: paretoAxis,
            valueYField: "pareto",
            categoryXField: "marketingName",
            // stroke: root.interfaceColors.get("alternativeBackground"),
            stroke: am5.color(0xFFB546),
            maskBullets: false
        }));

        paretoSeries.bullets.push(function () {
            return am5.Bullet.new(root, {
                locationY: 1,
                sprite: am5.Circle.new(root, {
                    radius: 5,
                    // fill: series.get("fill"),
                    // stroke: root.interfaceColors.get("alternativeBackground")
                    fill: am5.color(0xFFB546),
                    stroke:am5.color(0xFFB546)
                })
            })
        })

        series.data.setAll(data);
        paretoSeries.data.setAll(data);

        // Add legend
        legend = chart.children.push(
            am5.Legend.new(root, {
                nameField: 'name',
                fillField: 'color',
                strokeField: 'color',
                x: am5.percent(50),
                centerX: am5.percent(50)
            })
        );

        legend.labels.template.setAll({
            fontSize: 12,
            fontWeight: "300"
        });

        legend.data.setAll([
            {
                name: languageModel.getText("LT00000309", "80% cumulative"),
                color: am5.color(0x8093DC)
            },
            {
                name: languageModel.getText("LT00000310", "20% cumulative"),
                color: am5.color(0xB5B5B5)
            }
        ]);

        // Make stuff animate on load
        // https://www.amcharts.com/docs/v5/concepts/animations/
        series.appear();
        chart.appear(1000, 100);
    }

    function prepareParetoData() {
        var total = 0;

        for (var i = 0; i < data.length; i++) {
            var value = SPMSReportCategory == 1 ? data[i].validEULAAmt : data[i].validEULAQty;
            total += value;
        }

        var sum = 0;
        for (var i = 0; i < data.length; i++) {
            var value = SPMSReportCategory == 1 ? data[i].validEULAAmt : data[i].validEULAQty;
            sum += value;
            data[i].pareto = sum / total * 100;
        }
    }


    return {
        oninit: (vnode) => {
            data = vnode.attrs.data;
            //console.log("Chart Data : ");
            //console.log(data);
            SPMSReportCategory = vnode.attrs.SPMSReportCategory;
            if (vnode.attrs.events) {
                vnode.attrs.events.onChartDataChanged = onChartDataChanged;
            }
        },
        oncreate: (vnode) => {
            initChart();
        },
        onupdate: (vnode) => {
        },
        view: (vnode) => {
            return [
                m("div", { "class": "pareto-chart ac-container-hide-logo", "id": chartID },
                )
            ]
        } //end of view
    }
}